import {qs, qsArray} from './utilities/index';

let MPI = function () {
  if (MPI.prototype._singletonInstance) {
    return MPI.prototype._singletonInstance;
  }
  MPI.prototype._singletonInstance = this;

  this.initialize();
}

let SCORES = {
  v1: 0,
  v1x: 0,
  avx: 0,
  v1xld: 0,
  'tour-speed': 0,
  'tour-soft': 0,
  velocity: 0,
  trufeel: 0
}

MPI.prototype.initialize = function () {

  let self = this;

  self.maxPossibleScores = JSON.parse(JSON.stringify(SCORES));
  self.primaryValue = 0;
  self.secondaryValue = 0;
}

MPI.prototype.calcPossibleMax = function (history, weightIds, weightAmount) {

  let self = this;

  let questionElArray = [];
  let maxScoresArray = [];

  history.forEach(function(q){
    questionElArray.push(document.getElementById(q.id));
  });

  questionElArray.forEach(function(q){
    let answers = qsArray('[data-v1]', q);
    if (answers.length === 0) {
      return
    }

    let maxScore = JSON.parse(JSON.stringify(SCORES));
    let multiplier = 1;
    if (weightIds && weightIds.indexOf(q.id) !== -1) {
      multiplier = weightAmount;
    }

    answers.forEach(function(a){
      for(let prop in SCORES) {
        let score = parseFloat(a.getAttribute('data-' + prop + ''));
        maxScore[prop] = score * multiplier > maxScore[prop] ? score * multiplier : maxScore[prop];
      }
    });
    maxScoresArray.push(maxScore);
  });

  let maxPossibleScores = JSON.parse(JSON.stringify(SCORES));

  maxScoresArray.forEach(function(scores){
    for(let prop in SCORES) {
      maxPossibleScores[prop] += scores[prop];
    }
  });

  // console.log('possible max scores', maxPossibleScores);

  self.maxPossibleScores = maxPossibleScores;
}

MPI.prototype.calcPrimaryValue = function(id, score) {
  let self = this;
  let maxPossibleScores = self.maxPossibleScores;
  let value = Math.round((score / maxPossibleScores[id]) * 100);
  value = value < 81 ? 81 : value;
  self.primaryValue = value;
}

MPI.prototype.calcSecondaryValue = function(id, score) {
  let self = this;
  let maxPossibleScores = self.maxPossibleScores;
  let value = Math.round((score / maxPossibleScores[id]) * 100);
  value = value < 75 ? 75 : value;
  value = value === 100 ? 99 : value;
  if (value > self.primaryValue) {
    value = self.primaryValue - 1;
  }
  self.secondaryValue = value;
}

MPI.prototype.getPrimaryValue = function () {
  return this.primaryValue;
}

MPI.prototype.getSecondaryValue = function () {
  return this.secondaryValue;
}

export default MPI;
